import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { selectClientSelection } from "../../../../../redux/features/quotes/quote-create-advanced/selectors/clientSelectors";
import { useAppSelector } from "../../../../../redux/hooks/redux";
import { BaseModalComponent } from "../../../../common/BaseModalComponent";
import { JobsClients } from "../../../../jobs2/JobsClient";
import { colors } from "../../../../ui/colors";
import { getRecordEmail, getRecordPhone } from "../../../../../utils";

export const ClientInfo = () => {
  const client = useAppSelector(selectClientSelection);
  const isEmpty = !client;

  // const clientName = client?.type === "commercial" ? client?.clientCompanyName || "Unnamed Company" : `${client?.firstName} ${client?.lastName}`;

  const email = getRecordEmail(client) || "Not provided";
  const phone = getRecordPhone(client) || "Not provided";
  const address = client?.coverageArea?.address || "No coverage area selected";
  const isXs = useMediaQuery("(max-width:600px)");
  return (
    <Box
      sx={{
        maxWidth: "250px",
        width: "100%",
        minHeight: "200px",
        textAlign: "left",
        borderRadius: 3,
        px: 2,
        mb: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        border: isXs && 1,
        borderStyle: isXs && "dashed",
      }}
    >
      <Typography fontWeight={700} fontSize={18} mb={1} alignSelf={isXs && "center"}>
        Client Information
      </Typography>

      {isEmpty ? (
        <Box
          sx={{
            border: "1px dashed var(--fx-surface-borderstrong, #CBD5E1)",
            borderRadius: 3,
            px: 2,
            py: 1,
            mb: 4,
            textAlign: "center",
            minHeight: "150px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography fontWeight={700} fontSize={16} mb={1}>
            No client selected
          </Typography>

          <Typography fontSize={14} color={colors.gray[600]} mb={2}>
            Add a client to continue building this quote.
          </Typography>

          <BaseModalComponent
            modalKey="Select-Client-Quote"
            modalLabel="Select Client for Quote"
            defaultFullscreen={false}
            defaultSizes={{
              width: { xs: "95%", sm: "95%", md: "1200px" },
              height: { xs: "90%", sm: "85%" },
            }}
            onConfirmClose={() => {}}
            elementTrigger={
              <Button
                variant="contained"
                disableElevation
                sx={{
                  backgroundColor: colors.orange.base,
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                  px: 3,
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: colors.orange[600],
                    boxShadow: "none",
                  },
                  "&:active": {
                    boxShadow: "none",
                  },
                  "&:focus": {
                    boxShadow: "none",
                  },
                }}
              >
                Add Client
              </Button>
            }
          >
            <JobsClients />
          </BaseModalComponent>
        </Box>
      ) : (
        <Box textAlign={isXs ? "center" : "start"} marginBottom={1}>
          <Typography fontSize={14} color={colors.gray[800]} fontWeight={700}>
            {/* {clientName} */}
          </Typography>

          <Typography fontSize={14} color={colors.gray[600]}>
            {email}
          </Typography>

          <Typography fontSize={14} color={colors.gray[600]}>
            {phone}
          </Typography>

          <Typography fontSize={14} color={colors.gray[600]}>
            {address}
          </Typography>

          <BaseModalComponent
            defaultSizes={{ height: "50%", width: "80%" }}
            defaultFullscreen={false}
            onConfirmClose={() => {}}
            modalKey="Select-Client-Quote"
            modalLabel="Select Client for Quote"
            elementTrigger={
              <Button
                variant="outlined"
                sx={{
                  mt: 1,
                  background: colors.orange.base,
                  color: "white",
                  textTransform: "none",
                  borderColor: "transparent",
                  fontWeight: 600,
                  borderRadius: 2,
                  px: 3,
                  "&:hover": {
                    backgroundColor: colors.orange[600],
                    borderColor: "transparent",
                  },
                }}
              >
                Change Client
              </Button>
            }
          >
            <JobsClients />
          </BaseModalComponent>
        </Box>
      )}
    </Box>
  );
};
